// Scalar (text/number INPUT) fields only -- these are spread raw into the PUT body via _.pick.
// SELECT fields (condition, homeType, lotModel, valueSource) are NOT here: they hold { value } objects in the
// form and are unwrapped to their scalar `.value` explicitly in getChattelDetailsRequestBody.
export const chattelHomeDetailsScalarFieldKeys = [
  'make',
  'model',
  'yearBuilt',
  'width1',
  'width2',
  'length1',
  'length2',
  'estimatedCurrentValue',
  'serialNumber',
  'serialNumber2',
  'serialNumber3',
  'hudLabelNumber',
  'hudLabelNumber2',
  'hudLabelNumber3',
  'certOfTitleNumber',
  'manufacturerName',
  'manufacturerPhone',
  'manufacturerAddress',
  'manufacturerCity',
  'manufacturerState',
  'manufacturerZip',
];

// Every field on the Manufactured Home Details tab (scalars + the selects) -- used for the
// section's pending-changes badge and validation-error mapping. condition/homeType also appear on
// the Property tab (same columns), so a change to them counts on both tabs by design.
export const chattelHomeDetailsSectionFieldsKeys = [
  'condition',
  'homeType',
  'lotModel',
  'valueSource',
  ...chattelHomeDetailsScalarFieldKeys,
];
